<template>
  <span v-if="workingReward">
    <v-row class="mt-8">
      <v-col cols="12">
        <v-select label="Per ACH Transaction Type" outlined dense :items="Object.entries(AchTransactionTypes)" v-model="workingReward.achTransactionType"
          item-text="1" item-value="0" :rules="requiredRule" @change="onChange" ref="achTransactionType"/>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-text-field
          label="Per Transaction Reduction Amount"
          v-model="workingReward.perAchTrxTypeFeeReductionAmount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="perAchTrxTypeFeeReductionAmount"
        />
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12">
        <v-text-field
          label="Minimum Transaction Amount"
          v-model="workingReward.minimumTrxAmount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="minimumTrxAmount"
        />
      </v-col>
    </v-row>

    <v-row class="mt-6">
      <v-col cols="12">
        <v-text-field
          label="Fee Reduction Cap Amount"
          v-model="workingReward.feeReductionCapAmount"
          type="number"
          hint="Ex. 5.00"
          prefix="$"
          hide-spin-buttons
          dense
          :rules="requiredAndPositiveRule"
          @input="onChange"
          name="feeReductionCapAmount"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Prop, Watch,
} from 'vue-property-decorator';
import { PerAchTrxTypeFeeReductionReward } from '@/api/product/levelrewards/rewards';
import { AchTransactionTypes } from '@/api/product/levelrewards';
import { ValidationTool } from '@/util';

@Component
export default class PerAchTrxTypeFeeReductionRewardEditor extends Vue {
  @Prop()
  value!:PerAchTrxTypeFeeReductionReward;

  workingReward:PerAchTrxTypeFeeReductionReward | null = null;

  // Make available to template
  AchTransactionTypes:any = AchTransactionTypes;

  requiredRule:Array<any> = [(value: any) => {
    if (value === null || value === undefined || (Array.isArray(value) && value.length === 0)) {
      return 'Required';
    }
    return true;
  }];

  requiredAndPositiveRule:Array<any> = [ValidationTool.requiredAndPositiveRuleFunction];

  mounted() {
    this.initialize();
  }

  @Watch('value')
  initialize() {
    this.workingReward = this.value.clone() as PerAchTrxTypeFeeReductionReward;
  }

  onChange() {
    this.$emit('input', this.workingReward);
  }
}
</script>

<style lang="scss" scoped>
</style>
